<div
  class="container toastr-mobile-event"
  [ngClass]="options.messageClass"
  *ngIf="options.messageClass != 'notification'"
  [ngStyle]="{'top': touchY, 'left': touchX}"
  (click)="handleDismissToastr()"
  [draggable]="(isHandset$ | async)"
  (drag)="dragDimissToastr($event)"
  (touchmove)="dragDimissToastr($event)"
  (touchend)="dragDimissToastr($event)"
>
  <mat-icon class="icon" *ngIf="options.messageClass != 'basic'" [svgIcon]="icon"></mat-icon>
  <!-- <div class="color {{options.messageClass}}"></div> -->
  <div class="title" [class.left]="options.messageClass != 'basic'" [ngClass]="options.messageClass">
      {{ title }}
  </div>
  <div class="message">
    <div *ngIf="body?.label || body?.loading || body?.labelSecondary" class="message-header none-mobile">
      <span *ngIf="body?.label" class="secondary-title">{{body?.label}}</span>
      <divider  *ngIf="(body?.loading || body?.labelSecondary) && body?.label" alignment="vertical" position="center"></divider>
      <div style="width: 16px; height: 16px; position: relative;">
        <loading *ngIf="body?.loading" class="load-size" [size]="'23px'"></loading>
      </div>
      <span *ngIf="body?.labelSecondary" class="secondary-text">{{body?.labelSecondary}}</span>
    </div>
    <span class="text">{{message}}</span>
  </div>
  <div *ngIf="body?.isHour || body?.button" class="action">
    <div *ngIf="body?.isHour || body?.button" class="left-footer" >
      <span *ngIf="body?.isHour" class="date">
        Today {{hour | date: "HH':'mm"}}
      </span>
    </div>
    <div *ngIf="body?.button" class="right">
      <button-induxtry (action)="handleClick($event)" (click)="stopPropagation($event)"
          [buttonProperties]="body?.button">
      </button-induxtry >
    </div>
  </div>
  <mat-icon
    [svgIcon]="'close-circle'"
    class="close-button none-mobile"
    (click)="remove()"
  ></mat-icon>
</div>

<!-- <div
  class="container-notification toastr-mobile-event"
  *ngIf="options.messageClass == 'notification'"
  [ngStyle]="{'top': touchY, 'left': touchX}"
  (click)="handleDismissToastr()"
  [draggable]="(isHandset$ | async)"
  (drag)="dragDimissToastr($event)"
  (touchmove)="dragDimissToastr($event)"
  (touchend)="dragDimissToastr($event)"
>
  <div class="img-notification"></div>
  <div class="title-notification">
      {{ title }}
    </div>
    <div class="message-notification" [class.left]="options.messageClass !== 'basic'">
      <div class="message-header none-mobile">
        <span class="secondary-title">Label</span>
        <divider alignment="vertical" position="center"></divider>
        <div style="width: 16px; height: 16px; position: relative;">
          <loading [size]="'23px'" class="load-size"></loading>
        </div>
        <span class="secondary-text">label</span>
      </div>
      <span class="text">{{message}}</span>
    </div>
    <div class="action-notification">
      <div class="left-footer">
        <span class="date">
          Today {{hour | date: "HH':'mm"}}
        </span>
      </div>
      <div class="right">
        <button-induxtry (action)="handleClick($event)"
            [buttonProperties]="{ label: 'MORE INFO', customStyle: 'tertiary' }">
        </button-induxtry>
      </div>
    </div>
    <mat-icon (click)="remove()" class="close-button none-mobile">close</mat-icon>
</div> -->
